/* Landing ouxing — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'ouxing'). */


(()=>{
  // ====== datos reales (stock Dropi 2026-09-25) ======
  const STOCK={negro:{34:47,35:48,36:47,37:47,38:47,39:47,40:44},blanco:{34:49,35:47,36:48,37:43,38:46,39:48,40:49}};
  const COLORS={negro:{label:'Negro',sw:'linear-gradient(135deg,#1E1A17 50%,#EFE4D6 50%)',img:__A('ad-assets/real/estudio-negro.jpg')},blanco:{label:'Blanco',sw:'#fff',img:__A('ad-assets/real/estudio-blanco.jpg')}};
  const COMBOS={1:{price:139900,old:149900,name:'1 par'},2:{price:239900,old:299800,name:'2 pares'},3:{price:339900,old:449700,name:'3 pares · Para regalar'}};
  const SIZES=[34,35,36,37,38,39,40];
  // tabla provisional largo de pie (cm) → talla CO — PENDIENTE horma real
  const SZ=[[34,22.0],[35,22.5],[36,23.0],[37,23.8],[38,24.5],[39,25.0],[40,25.5]];
  const ORDER_ENDPOINT=''; // PENDIENTE: URL que recibe el pedido (Shopify/Dropi/webhook). Vacío = modo prueba
  const fmt=n=>'$'+n.toLocaleString('es-CO');

  let combo=2, pairs=[{c:'negro',s:null},{c:'blanco',s:null},{c:'blanco',s:null}];

  // ====== galería ======
  const gal=[
    [__A('ad-assets/01-hero.jpg'),'Negro + Blanco'],
    [__A('ad-assets/02-lifestyle-oficina.jpg'),'En uso',__A('ad-assets/real/look-escalas-blanco.jpg')],
    [__A('ad-assets/03-altura-pareja.jpg'),'Altura Pareja',__A('ad-assets/real/estudio-negro.jpg')],
    [__A('ad-assets/04-vs-tacon.jpg'),'NIVEL vs. tacón',null],
    [__A('ad-assets/07-suela.jpg'),'Suela inyectada',__A('ad-assets/real/estudio-blanco.jpg')],
    [__A('ad-assets/real/estudio-negro.jpg'),'Negro · foto real'],
    [__A('ad-assets/real/estudio-blanco.jpg'),'Blanco · foto real']
  ];
  const main=document.getElementById('galMain'),tag=document.getElementById('galTag'),th=document.getElementById('galThumbs');
  gal.forEach(([src,label,fb],i)=>{
    const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',label);
    const im=new Image();im.alt=label;im.loading='lazy';im.src=src;
    im.onerror=()=>{ if(fb){im.onerror=()=>b.remove();im.src=fb;gal[i][0]=fb;} else b.remove(); };
    b.appendChild(im);b.onclick=()=>show(gal[i][0],label,b);th.appendChild(b);
    if(i===0)b.classList.add('on');
  });
  function show(src,label,btn){main.style.opacity=.3;setTimeout(()=>{main.src=src;main.style.opacity=1},120);tag.textContent=label;th.querySelectorAll('button').forEach(x=>x.classList.toggle('on',x===btn));}

  // fallback de imágenes aún no generadas
  document.querySelectorAll('img[data-fb]').forEach(im=>{
    const set=()=>{if(im.dataset.fbDone)return;im.dataset.fbDone=1;im.src=im.dataset.fb;};
    im.addEventListener('error',set);
    if(im.complete&&im.naturalWidth===0)set();
  });

  // ====== combos y pares ======
  const comboEls=[...document.querySelectorAll('.combo')];
  comboEls.forEach(el=>el.addEventListener('click',()=>{combo=+el.dataset.n;el.querySelector('input').checked=true;render();}));
  function stockTxt(c,s){ if(!s)return ['Elige tu talla','']; const n=STOCK[c][s]; return [n<=45?`¡Quedan ${n} en talla ${s}!`:`${n} disponibles en talla ${s}`, n<=45?'low':''];}
  function render(){
    comboEls.forEach(el=>el.classList.toggle('on',+el.dataset.n===combo));
    if(combo===2){pairs[0].c=pairs[0].c||'negro';}
    const box=document.getElementById('pairs');box.innerHTML='';
    for(let i=0;i<1;i++){
      const p=pairs[i];const [st,cls]=stockTxt(p.c,p.s);
      const d=document.createElement('div');d.className='pair';
      d.innerHTML=`<div class="pair-h"><span>${combo>1?'Tus '+combo+' pares':'Tu par'}</span><span class="stock ${cls}">${st}</span></div>
        <div class="opts">${Object.entries(COLORS).map(([k,v])=>`<button type="button" class="opt ${p.c===k?'on':''}" data-i="${i}" data-c="${k}"><span class="sw" style="background:${v.sw}"></span>${v.label}</button>`).join('')}</div>
        <div class="opts sizes">${SIZES.map(s=>`<button type="button" class="opt size ${p.s===s?'on':''}" data-i="${i}" data-s="${s}">${s}</button>`).join('')}</div>`;
      box.appendChild(d);
    }
    box.querySelectorAll('[data-c]').forEach(b=>b.onclick=()=>{const i=+b.dataset.i;pairs[i].c=b.dataset.c;render();show(COLORS[b.dataset.c].img,COLORS[b.dataset.c].label+' · foto real',null);});
    box.querySelectorAll('[data-s]').forEach(b=>b.onclick=()=>{pairs[+b.dataset.i].s=+b.dataset.s;render();});
    const C=COMBOS[combo];
    document.querySelectorAll('[data-cta-price]').forEach(e=>e.textContent=fmt(C.price)+' · pagas al recibir');
    document.getElementById('stName').textContent='Tenis NIVEL · '+C.name;
    document.getElementById('stPrice').textContent=fmt(C.price)+' · pagas al recibir';
    document.querySelector('[data-final-price]').textContent=fmt(C.price);
    document.querySelector('[data-final-old]').textContent=fmt(C.old);
    document.getElementById('giftNote').textContent=combo>1?`+ Envío gratis por llevar ${combo} pares`:'Pasa a 2 pares y el envío te sale gratis';
  }
  render();

  // ====== diagrama Altura Pareja ======
  // pie de perfil: hy = base del talón, ty = base de la punta (y del SVG; suelo en 200)
  function footPath(hy,ty){const hx=88,tx=322,sl=(ty-hy)/(tx-hx),y=x=>hy+sl*(x-hx);
    return `M${hx} ${hy} C${hx-8} ${hy-8} ${hx-6} ${hy-40} ${hx+4} ${hy-66} C${hx+10} ${hy-80} ${hx+44} ${hy-80} ${hx+50} ${hy-64}`+
      ` C${hx+56} ${hy-44} ${hx+70} ${y(hx+120)-38} ${hx+130} ${y(hx+130)-30} L${tx-14} ${ty-16} C${tx} ${ty-14} ${tx+6} ${ty-2} ${tx-4} ${ty} Z`;}
  function solePath(k,hy,ty){
    if(k==='tacon')return `M86 200 L100 200 L104 ${hy+4} L86 ${hy+4} Z M104 ${hy+4} L${322} ${ty+2} L${326} 200 L${300} 200 L${300} ${ty+2}`;
    return `M78 ${hy} L330 ${ty} C342 ${ty} 346 ${ty+6} 344 ${Math.min(ty+12,196)} L340 200 L74 200 C64 200 62 ${hy+8} 78 ${hy} Z`;}
  const D={
    tacon:{hy:130,ty:196,alt:'8 cm',ang:'~35°',hrs:'~3,5 h',tx:'Pie inclinado: ~35°',
           cap:'El tacón te sube levantando solo el talón. Todo el peso se va a la punta y la cuenta llega en la tarde.'},
    plano:{hy:188,ty:188,alt:'0 cm',ang:'0°',hrs:'todo el día',tx:'Pie parejo: 0°',
           cap:'El tenis plano no te inclina, pero tampoco te sube: cómoda, pero "bajita".'},
    nivel:{hy:152,ty:160,alt:'5 cm',ang:'casi 0°',hrs:'todo el día',tx:'Pie casi parejo',
           cap:'NIVEL sube el pie completo: talón y punta juntos. La altura del tacón bajo, con el pie parejo.'}
  };
  const $=id=>document.getElementById(id);
  function diag(k){const d=D[k];$('sole').setAttribute('d',solePath(k,d.hy,d.ty));$('foot').setAttribute('d',footPath(d.hy,d.ty));
    const h=200-d.hy;const show=k!=='plano';
    $('hLine').setAttribute('x1',70);$('hLine').setAttribute('x2',70);$('hLine').setAttribute('y1',200);$('hLine').setAttribute('y2',d.hy+4);
    $('hHead').setAttribute('d',`M64 ${d.hy+12} L70 ${d.hy+2} L76 ${d.hy+12} Z`);
    $('hTxt').setAttribute('x',60);$('hTxt').setAttribute('y',Math.max(40,d.hy+28));$('hTxt').textContent='+'+d.alt;$('hArrow').style.opacity=show?1:0;
    $('angTxt').textContent=d.tx;$('rAlt').textContent=d.alt;$('rAng').textContent=d.ang;$('rHrs').textContent=d.hrs;$('diagCap').textContent=d.cap;
    document.querySelectorAll('.diag-tabs button').forEach(b=>b.classList.toggle('on',b.dataset.d===k));}
  document.querySelectorAll('.diag-tabs button').forEach(b=>b.onclick=()=>diag(b.dataset.d));
  diag('nivel');

  // ====== calculadora de talla ======
  const tb=document.querySelector('#szTable tbody');
  tb.innerHTML=SZ.map(([t,c])=>`<tr data-t="${t}"><td>${t}</td><td>${c.toFixed(1).replace('.',',')} cm</td></tr>`).join('');
  $('cm').addEventListener('input',e=>{
    const v=parseFloat(String(e.target.value).replace(',','.'));const out=$('calcOut');
    tb.querySelectorAll('tr').forEach(r=>r.classList.remove('hit'));
    if(!v||v<18||v>30){out.innerHTML='Escribe tu medida y te decimos tu talla.';return;}
    let hit=SZ.find(([t,c])=>v<=c+0.1);
    if(!hit){out.innerHTML='Tu medida pasa de la talla 40: por ahora este modelo llega hasta la 40.';return;}
    const [t]=hit;tb.querySelector(`tr[data-t="${t}"]`).classList.add('hit');
    out.innerHTML=`<span class="muted">Tu talla NIVEL es</span><b class="big">${t}</b><button type="button" class="size-help" id="useSize">Usar talla ${t} en mi pedido ↑</button>`;
    $('useSize').onclick=()=>{pairs.forEach(p=>p.s=t);render();document.getElementById('comprar').scrollIntoView({behavior:'smooth'});};
  });

  // ====== scroll helpers ======
  document.querySelectorAll('[data-goto]').forEach(b=>b.onclick=()=>document.querySelector(b.dataset.goto).scrollIntoView({behavior:'smooth'}));

  // ====== countdown real al 31 oct 2026 23:59 (Bogotá, UTC-5) ======
  const END=new Date('2026-11-01T04:59:59Z').getTime();
  function tick(){const ms=END-Date.now();const el=document.querySelectorAll('[data-cd]');
    if(ms<=0){el.forEach(e=>e.textContent='ya terminó');return;}
    const d=Math.floor(ms/864e5),h=Math.floor(ms%864e5/36e5),m=Math.floor(ms%36e5/6e4),s=Math.floor(ms%6e4/1e3);
    el.forEach(e=>e.textContent=`${d}d ${String(h).padStart(2,'0')}h ${String(m).padStart(2,'0')}m ${String(s).padStart(2,'0')}s`);}
  tick();setInterval(tick,1000);

  // ====== sticky ======
  const sticky=$('sticky'),buyBox=document.querySelector('.buy .cta');
  new IntersectionObserver(([e])=>sticky.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0),{threshold:0}).observe(buyBox);

  // ====== checkout COD ======
  const modal=$('modal');
  function missing(){return pairs[0].s?-1:0;}
  function summary(){const C=COMBOS[combo];let h='';
    for(let i=0;i<combo;i++)h+=`<div class="sum-row"><span>Par ${i+1} · ${COLORS[pairs[i].c].label} · talla ${pairs[i].s}</span></div>`;
    h+=`<div class="sum-row"><span>Envío</span><span>${combo>1?'Gratis':'Incluido'}</span></div><div class="sum-row"><span>🎁 3 guías en PDF</span><span>Gratis</span></div><div class="sum-row tot"><span>Total al recibir</span><span>${fmt(C.price)}</span></div>`;return h;}
  document.querySelectorAll('[data-buy]').forEach(b=>b.addEventListener('click',()=>{
    const m=missing();
    if(m>=0){__needSize(document.querySelector('#pairs .sizes')||document.getElementById('pairs'));
      setTimeout(()=>{const p=document.querySelectorAll('.pair')[m];if(p){p.style.boxShadow='0 0 0 3px var(--terra)';p.querySelector('.stock').textContent='👉 Elige la talla de este par';setTimeout(()=>p.style.boxShadow='',1800);}},450);return;}
    window.__ouxing_SEL={color:COLORS[pairs[0].c].label,size:pairs[0].s,qty:combo};
    try{localStorage.setItem('te_regalo','ouxing|'+Date.now())}catch(e){}if(window.ouxingTriggerCOD){window.ouxingTriggerCOD();return;}
    $('sum').innerHTML=summary();$('formView').hidden=false;$('okView').hidden=true;modal.classList.add('open');document.body.style.overflow='hidden';
  }));
  modal.addEventListener('click',e=>{if(e.target===modal||e.target.hasAttribute('data-close')){modal.classList.remove('open');document.body.style.overflow='';}});
  $('form').addEventListener('submit',e=>{e.preventDefault();const f=e.target,fd=new FormData(f);
    for(const [k,v] of fd.entries()){if(k!=='pie'&&!String(v).trim()){$('err').textContent='Completa todos los campos, por favor.';return;}}
    const cel=String(fd.get('cel')).replace(/\D/g,'');if(cel.length<10){$('err').textContent='Revisa tu número de celular (10 dígitos).';return;}
    $('err').textContent='';const C=COMBOS[combo];
    const order={combo:C.name,total:C.price,pares:pairs.slice(0,combo).map(p=>({color:COLORS[p.c].label,talla:p.s})),
      nombre:fd.get('nombre'),celular:cel,departamento:fd.get('depto'),ciudad:fd.get('ciudad'),direccion:fd.get('dir'),barrio:fd.get('barrio'),
      largo_pie_cm:String(fd.get('pie')||'').trim(),fecha:new Date().toISOString()};
    const btn=f.querySelector('button[type=submit]');btn.disabled=true;
    const done=()=>{$('formView').hidden=true;$('okView').hidden=false;btn.disabled=false;};
    if(!ORDER_ENDPOINT){console.warn('MODO PRUEBA: configura ORDER_ENDPOINT',order);done();return;}
    fetch(ORDER_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(order)})
      .then(r=>{if(!r.ok)throw 0;done();})
      .catch(()=>{btn.disabled=false;$('err').textContent='No pudimos registrar tu pedido. Intenta de nuevo en un momento.';});
  });
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function current() {
    var s = window.__ouxing_SEL || {};
    var V = window.OUXING_VARIANTS || [];
    var n = function (x) { return String(x || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
    var v = V.filter(function (x) { return n(x.color) === n(s.color) && String(x.talla) === String(s.size); })[0];
    return v ? { id: v.id, qty: s.qty || 1 } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__ouxing-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.ouxingTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
